import React, { useRef, useState } from 'react';
import {
	MediaGrid,
	MediaThumb,
	MediaThumbImg,
	VideoIconContainer,
} from './mediaStyles';
import { OverlayEventDetail } from '@ionic/core/components';
import { VideoIcon } from '../../Global/Icons/Icons';
import { IonModal } from '@ionic/react';
import { CloseButton } from '../../TrailPage/VirtualTour/virtualTourStyles';
import { close } from 'ionicons/icons';
import MediaModal from './MediaModal';
import { Media } from '../../../pages/innerPages/DELETEMEbookmarks';
import { checkImage } from '../../componentUtils';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';

type GridProps = {
	media: Media[];
	listKey?: string;
};

const Grid: React.FC<GridProps> = ({ media, listKey }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	const lightbox = useRef(null);
	const handleClick = (item: Media, i: number) => {
		if (!network_status) return;
		console.log(item, i);
		setActiveIndex(i);
		setIsOpen(true);
	};
	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};

	return (
		<>
			<MediaGrid>
				{media.map((item, i) => {
					return (
						<MediaThumb
							key={`${item.caption}-${item.src ?? item.videoSrc ?? i}`}
							onClick={() => {
								handleClick(item, i);
							}}>
							<MediaThumbImg src={checkImage(item.src)} />
							<p>{item.caption}</p>
							{listKey && listKey === 'videos' && (
								<VideoIconContainer>
									<VideoIcon />
								</VideoIconContainer>
							)}
						</MediaThumb>
					);
				})}
			</MediaGrid>
			<IonModal
				isOpen={isOpen}
				ref={lightbox}
				onWillDismiss={(ev: CustomEvent<OverlayEventDetail>) =>
					onWillDismiss(ev)
				}>
				<MediaModal media={media} activeIndex={activeIndex} />
				<CloseButton onClick={() => setIsOpen(false)} icon={close} />
			</IonModal>
		</>
	);
};

export default Grid;
